import { render, staticRenderFns } from "./AlertFileUpload.vue?vue&type=template&id=4da99a2c&"
import script from "./AlertFileUpload.vue?vue&type=script&lang=js&"
export * from "./AlertFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports